import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { DbRecord } from '../db-record'
import { Project } from '../project'
import { RuntimeService } from '../runtime.service'
import { RatingService } from '../rating.service'
import { FilterService } from '../filter.service'
import { SortService } from '../sort.service'
import { CriterionService } from '../criterion.service'
import { DbRecordService } from '../db-record.service'
import { PageService } from '../page.service'

@Component({
  selector: 'app-db-record-box',
  templateUrl: './db-record-box.component.html',
  styleUrls: ['./db-record-box.component.css']
})
export class DbRecordBoxComponent implements OnInit {
  @Input() dbRecord: DbRecord
  @Input() order: number
  project: Project
  private _searchDetailsOn = false;
  isInsertRTabstract = false;

  constructor(
    private elr: ElementRef,
    private rs: RuntimeService,
    public rats: RatingService,
    private fs: FilterService,
    private ss: SortService,
    private cs: CriterionService,
    private dbrs: DbRecordService,
    private pgs: PageService
  ) {
    this.project = this.rs.currentProject
  }


  ngOnInit() {
    //console.log(111, this.dbRecord)
  }

  jumpHome() {
    window.scrollTo(0, 0);
  }

  jumpTop() {
    let el = this.elr.nativeElement;
    window.scrollTo(el.offsetLeft, el.offsetTop);
  }

  jumpNext() {
    let nextSibling = this.elr.nativeElement.nextSibling;
    if (!nextSibling.tagName) {
      this.jumpHome();
      this.pgs.nextPage();
    } else {
      window.scrollTo(nextSibling.offsetLeft, nextSibling.offsetTop);
    }

  }

  jumpPrev() {
    let prevSibling = this.elr.nativeElement.previousSibling;
    window.scrollTo(prevSibling.offsetLeft, prevSibling.offsetTop);
  }

  get notes() {
    return this.dbrs.notes(this.dbRecord);
  }

  get hasOwnerNote() {
    return this.dbrs.hasOwnerNote(this.dbRecord);
  }

  get searchDetailsOn() {
    return this._searchDetailsOn;
  }

  get title() {
    return this.ss.highlightSortHits(
      this.dbRecord,
      this.project.highlightHits(
        this.fs.highlightSearchHits(this.dbRecord.title)));
  }

  get abstract() {
    return this.ss.highlightSortHits(this.dbRecord,
      this.project.highlightHits(
        this.fs.highlightSearchHits(this.dbRecord.abstract)));
  }

  get weight() {
    return Math.round(-1 * this.cs.currentCriterion.valuesMap.get(this.dbRecord.id));
  }

  get showRTags() {
    return this.rats.showRTags(this.dbRecord);
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/db-record-box/db-record-box.component.ts